<div
  *ngFor="let file of control.value; index as i"
  class="file-info"
  [ngClass]="{ 'summary-file-info': isSummary }"
>
  <div class="file-info-label">{{ uploadedFileLabel | translate }}</div>
  <div
    class="file-info-filename"
    (click)="downloadFile(file.name || file.filename)"
  >
    {{ file.name || file.filename | sliceGenericPrefix: genericPrefix }}
  </div>
  <button
    class="remove-button"
    mat-icon-button
    disableRipple
    (click)="openDialog($event, i)"
  >
    <span class="icon icon-trash"></span>
  </button>
</div>
<mat-error *ngIf="error">
  {{ error }}
</mat-error>
